import { defaultFlagValues } from "./defaultFlagValues";

export const useFeatureFlags = () => {
  return defaultFlagValues;
};
